import { registryApp } from "./registry";
import { removeEmptyMenuItems } from "./config";
import { MENUS } from "./consts";
import type { MenuComponentSpec, MenuSpec } from "./types";

function createImporter(component: string) {
  return function importer(path: string) {
    return import(`../features/${component}/${path}/index.ts`);
  };
}

async function registryComponent(spec: MenuComponentSpec, category?: string) {
  if (__DEV__) {
    console.debug("registry subapp:", spec.component);
  }
  const importFromComponent = createImporter(spec.component);

  let routes = [];
  try {
    routes = (await importFromComponent(`routes`)).default;
    __DEV__ && console.debug("registryComponent routes", routes);
  } catch (e) {
    routes = [
      {
        path: "/",
        component: () => import(`../features/${spec.component}/App.vue`),
      },
    ];
  }
  const helper = registryApp({
    category: spec.category || category || spec.id,
    id: spec.id,
    index: spec.index,
    routes,
  });
  (await importFromComponent(`helper`)).setHelper(helper);
}

function shouldShow(spec: any) {
  return (
    (!!spec.submenu && spec.submenu.length > 0) ||
    !!spec.component ||
    !!spec.link ||
    !!spec.extraLink ||
    !!spec.isTitle ||
    !!spec.type
  );
}

async function doLoadComponents(menusSpec: readonly MenuSpec[], category?: string) {
  // const transducer = compose(
  //   removeEmptyMenuItems ? (v: MenuSpec) => filter(v, shouldShow) : identity,
  //   partialRight(map, (spec: MenuSpec) => {
  //     if ("component" in spec) {
  //       registryComponent(spec, category);
  //     }

  //     let submenu = undefined;
  //     if ("submenu" in spec) {
  //       submenu = doLoadComponents(spec.submenu, spec.id);
  //     }

  //     let id = spec.id;
  //     if (category) {
  //       id = `${category}-${spec.id}`;
  //     }

  //     return {
  //       ...spec,
  //       id,
  //       submenu,
  //     };
  //   }),
  // );

  const menus: MenuSpec[] = [];
  for (const spec of menusSpec) {
    let id = spec.id;
    if (spec.category || category) {
      id = `${spec.category || category}-${spec.id}`;
    }

    if ("component" in spec) {
      await registryComponent(spec, category);
      menus.push({
        ...spec,
        id,
      });
      continue;
    }

    if ("submenu" in spec) {
      const submenu = await doLoadComponents(spec.submenu, spec.id);
      menus.push({
        ...spec,
        id,
        submenu,
      });
      continue;
    }

    menus.push(spec);
  }

  return removeEmptyMenuItems ? menus.filter(shouldShow) : menus;
}

let menus: MenuSpec[] | null = null;
export async function buildMenus() {
  menus = await doLoadComponents(MENUS);
}

export function getMenus(region: string) {
  if (__DEV__) {
    console.assert(menus !== null, "please invoke buildMenus before getMenus");

    console.debug("menus:", menus);
  }

  return (menus ?? []).filter(item => {
    const denyItem = item.denyReasons;
    if (denyItem) {
      if (
        denyItem.some(reason => {
          return !!reason.regions?.has(region);
        })
      ) {
        return false;
      }
    }

    const allowItem = item.allowReasons;
    if (allowItem) {
      return allowItem.some(reason => {
        return !!reason.regions?.has(region);
      });
    }

    return true;
  });
}
